/* GranLusso カートドロワー拡張：追加提案の投入
   ドロワーは再描画でHTMLが差し替わるため、document委譲＋監視で常駐させる */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gl-up-add]');
    if (!btn) return;
    var item = btn.closest('[data-gl-up-item]');
    var sel = item && item.querySelector('[data-gl-up-sel]');
    if (!sel || !sel.value) return;
    btn.classList.add('is-busy');
    btn.textContent = '追加中…';
    var drawer = document.querySelector('cart-drawer');
    var sections = (drawer && drawer.getSectionsToRender)
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(sel.value, 10), quantity: 1 }], sections: sections })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (drawer && drawer.renderContents && res.sections) drawer.renderContents(res);
      })
      .catch(function () { btn.classList.remove('is-busy'); btn.textContent = 'もう一度'; });
  });


  /* ---- 追加した商品を光らせる / カートアイコンを跳ねさせる ---- */
  var GL_LAST = null;   // 直近で追加したバリアントID

  // fetch を包んで /cart/add.js のバリアントIDを覚える
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') > -1 && init && init.body) {
        var body = init.body;
        if (typeof FormData !== 'undefined' && body instanceof FormData) {
          // テーマ本体(Dawn系)は FormData で送ってくる
          var v = body.get('id');
          if (v) GL_LAST = String(v);
        } else if (typeof body === 'string') {
          try {
            var b = JSON.parse(body);
            if (b && b.items && b.items[0]) GL_LAST = String(b.items[0].id);
            else if (b && b.id) GL_LAST = String(b.id);
          } catch (e) {
            var m = String(body).match(/(?:^|&)id=(\d+)/);
            if (m) GL_LAST = m[1];
          }
        }
      }
    } catch (e) {}
    return _fetch.apply(this, arguments);
  };

  // テーマ本来のフォーム送信(product-form)からの追加も拾う
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"], [data-gl-bundle-cta]');
    if (!btn) return;
    var f = btn.closest('form');
    var id = f && f.querySelector('[name="id"]');
    if (id && id.value) GL_LAST = String(id.value);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    var id = f.querySelector('[name="id"]');
    if (id) GL_LAST = String(id.value);
  }, true);

  function flashAdded() {
    if (!GL_LAST) return;
    var q = document.querySelector('[data-quantity-variant-id="' + GL_LAST + '"]');
    if (!q) return;
    var row = q.closest('tr.cart-item, .cart-item');
    if (!row || row.dataset.glFlashed === GL_LAST) return;
    row.dataset.glFlashed = GL_LAST;
    row.classList.add('gl-just-added');
    row.scrollIntoView({ block: 'nearest' });
    setTimeout(function () { row.classList.remove('gl-just-added'); }, 1800);
  }

  var glCount = null;
  function bounceBubble() {
    var b = document.querySelector('.cart-count-bubble');
    if (!b) { glCount = 0; return; }
    var n = parseInt((b.textContent || '').trim(), 10);
    if (isNaN(n)) return;
    if (glCount !== null && n > glCount) {
      b.classList.remove('gl-bump');
      void b.offsetWidth;
      b.classList.add('gl-bump');
    }
    glCount = n;
  }

  var glT = null;
  new MutationObserver(function () {
    clearTimeout(glT);
    glT = setTimeout(function () { flashAdded(); bounceBubble(); }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
  bounceBubble();


  /* ---- 商品ページの購入ボタンを「今すぐ購入」＋カートアイコンにする（全商品共通） ---- */
  var GL_ICON = '<svg class="gl-cart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1.6"/><circle cx="18.5" cy="21" r="1.6"/><path d="M2 3h3l2.7 12.1a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.55L22 7H6"/></svg>';
  function glFixAddButtons() {
    document.querySelectorAll('button[name="add"]').forEach(function (b) {
      if (b.querySelector('svg.gl-cart')) return;
      var t = b.querySelector('span:not(.visually-hidden)') || b;
      t.innerHTML = GL_ICON + '<span>今すぐ購入</span>';
    });
  }
  glFixAddButtons();
  document.addEventListener('DOMContentLoaded', glFixAddButtons);
  var glBtnT = null;
  new MutationObserver(function () {
    clearTimeout(glBtnT);
    glBtnT = setTimeout(glFixAddButtons, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });


  /* ---- ★セット商品の「発送個数」を注文に必ず残す ----
     TeemDropの連携は1バリアント=1個しか伝えられない。
     2個セットが売れても仕入れ元へは1個しか発注されないので、
     注文明細に発送個数を書き込んで、発注担当が気づけるようにする。 */
  function glSetQtyProperty() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      var picked = null;
      document.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (r) {
        var v = (r.value || '').trim();
        if (/^\d+個(セット)?$/.test(v)) picked = v;
      });
      if (!picked) {
        var sel = document.querySelector('variant-selects select');
        if (sel && /^\d+個(セット)?$/.test((sel.value || '').trim())) picked = sel.value.trim();
      }
      var input = f.querySelector('input[name="properties[発送個数]"]');
      if (!picked) { if (input) input.remove(); return; }
      var n = parseInt(picked, 10) || 1;
      if (n < 2) { if (input) input.remove(); return; }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[発送個数]';
        f.appendChild(input);
      }
      input.value = n + '個';
    });
  }
  glSetQtyProperty();
  var glQT = null;
  new MutationObserver(function () {
    clearTimeout(glQT);
    glQT = setTimeout(glSetQtyProperty, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(glSetQtyProperty, 30);
  }, true);


  /* ---- ★セット内の個別指定（2個目・3個目にどれを入れるか）を注文に残す ---- */
  function glPickProperties() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      // 既存の指定欄を一旦消す
      f.querySelectorAll('[data-gl-pick-prop]').forEach(function (e) { e.remove(); });
      var card = document.querySelector('[data-gl-bundle="top"] .gl-bd__card.is-on');
      if (!card) return;
      var picks = card.querySelectorAll('[data-gl-pick]');
      if (!picks.length) return;
      var label = card.querySelector('.gl-bd__picks-lb');
      var optName = label ? label.textContent.replace('をそれぞれ選ぶ', '').trim() : '内容';
      picks.forEach(function (sel) {
        var n = sel.getAttribute('data-gl-no');
        var i = document.createElement('input');
        i.type = 'hidden';
        i.setAttribute('data-gl-pick-prop', '1');
        i.name = 'properties[' + n + '個目の' + optName + ']';
        i.value = sel.value;
        f.appendChild(i);
      });
    });
  }
  glPickProperties();
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-gl-pick]')) glPickProperties();
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.gl-bd__card')) setTimeout(glPickProperties, 120);
  }, true);
  var glPT = null;
  new MutationObserver(function () {
    clearTimeout(glPT); glPT = setTimeout(glPickProperties, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

})();
